<section *ngIf="isgroupviewaccess" >
 
  <div class="flex justify-between items-end">
    <div>
      <h1>groups</h1>
    </div>
    <div>
      <button *ngIf="iscreateaccess" (click)="openGroupModal()" class="btn btn-sm flex items-center btn-primary"><i class="ri-add-line"></i>
        Create Group</button>
    </div>
  </div>
 
  <div class="mt-5">
    <div class="bg-white border border-gray-200 rounded-lg flex items-center w-2/5 px-3"><i
        class="ri-search-2-line"></i> <input type="text" [(ngModel)]="searchStr" (ngModelChange)="search()"
        placeholder="Search" class="outline-none ml-2 w-full py-2">
    </div>
  </div>
 
  <div class="p-5 bg-white rounded-lg mt-5 border"  *ngIf="isviewaccess" >
 
    <div class="overflow-x-auto">
      <table class="table table-auto w-full">
        <!-- head -->
        <thead>
          <tr>
            <th class="w-auto">Group Name</th>
            <th class="w-28">No. of students</th>
            <th class="w-56">Action</th>
          </tr>
        </thead>
        <tbody>
 
          @if (isFetching) {
          <tr>
            <td colspan="5" class="py-10">
              <div class="flex justify-center">
                <app-loader></app-loader>
              </div>
            </td>
          </tr>
          } @else {
          <!-- Data rows if groupList has content -->
          @if (groupList.length > 0) {
          @for (i of groupList; track $index) {
          <tr>
            <td class="break-words">{{ i?.group_name }}</td>
            <td>{{ i?.student_count ?? 0 }}</td>
            <td>
              <div class="flex gap-2 justify-center">
                <!-- <button *ngIf="isviewaccess" class="btn btn-sm flex items-center btn-light" (click)="openPerformance(i.id)"><i class="ri-eye-line"></i></button> -->
                <button *ngIf="iseditaccess" class="btn btn-sm flex items-center btn-light" (click)="openGroupModal(i)"><i
                    class="ri-pencil-line"></i></button>
                <button *ngIf="isdeleteaccess" class="btn btn-sm flex items-center btn-light" (click)="deleteGroup(i.id)"><i
                    class="ri-delete-bin-line"></i></button>
                <button *ngIf="isassignaccess" class="btn btn-sm flex items-center btn-light" (click)="openAddStudentModal(i)"><i
                    class="ri-user-add-line"></i></button>
                <a *ngIf="isperformanceaccess" [routerLink]="['/performance', 'group', i.id]" class="btn btn-sm flex items-center btn-light"><i
                    class="ri-bar-chart-line"></i></a>
                <button *ngIf="ischatstudentaccess" class="btn btn-sm flex items-center btn-light" (click)="openChat(i.id)"><i class="ri-message-3-line"></i></button>
              </div>
            </td>
          </tr>
          }
          } @else {
          <!-- No records message -->
          <tr>
            <td colspan="5" class="py-10">
              <div class="flex justify-center">
                <p class="font-mono italic">No data to display.</p>
              </div>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>
 
 
 
  </div>
 
  <div class="mt-5 flex justify-center">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>
 
</section>
 
<!-- create/edit group modal -->
<dialog id="addGroupModal" class="modal" #modalGroup appPreventEscClose>
  <div class="modal-box max-w-sm">
 
    <div class="flex justify-between items-center font-semibold">
      <p>{{groupForm.value.id ? 'Update' : 'Create'}} Group</p>
      <button (click)="closeGroupModal()" class="btn btn-circle btn-sm btn-light flex justify-center items-center"><i
          class="ri-close-line"></i></button>
 
    </div>
    <hr class="mt-4 mb-1">
    <form [formGroup]="groupForm" (submit)="onSubmit()">
 
      <label class="form-control w-full ">
        <div class="label">
          <span class="label-text">Group Name</span>
        </div>
        <input type="text" formControlName="group_name" placeholder="Type here" class="input input-bordered w-full " />
        @if (groupForm.get('group_name')?.touched && groupForm.get('group_name')?.invalid) {
        <div class="mt-1 text-sm text-red-600">
          @if (groupForm.get('group_name')?.errors?.['required']) {
          <span>Group name is required.</span>
          } @else if (groupForm.get('group_name')?.errors?.['maxlength']) {
          <span>Group name must be 50 characters or fewer.</span>
          } @else if (groupForm.get('group_name')?.errors?.['pattern']) {
          <span>Only letters, numbers, spaces, hyphen (-) and ampersand (&) are allowed.</span>
          } @else if (groupForm.get('group_name')?.errors?.['whitespace']) {
          <span>Group name cannot be only spaces.</span>
          } @else if (groupForm.get('group_name')?.errors?.['consecutiveSpaces']) {
          <span>Consecutive spaces are not allowed.</span>
          } @else if (groupForm.get('group_name')?.errors?.['minlength']) {
          <span>Group name must be at least 2 characters.</span>
          }
        </div>
        }
      </label>
 
 
      <div class="mt-3 flex justify-end gap-3">
        <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
          @if (isreqSending) {
          <i class="ri-loader-2-line animate-spin"></i>
          }@else {
          <span>Save</span>
          }
        </button>
      </div>
    </form>
 
  </div>
</dialog>
<!-- create/edit group modal -->
 
 
 
<app-selectable-student-list-modal [isOpen]="isStudentSelectModalOpen" type="group" [categoryData]="studentSelectdata"
  (closeModalemmit)="closedModal($event)"></app-selectable-student-list-modal>
 